var patients = require('./tripletrax.patients.js');
var utils = require('./tripletrax.utils.js');
var ajax = require('./tripletrax.ajax.js');
var validator = require('./tripletrax.validator.js');
var views = require('./tripletrax.views.js');

function registerMonitoringEvents() {

    // Auswahl Abfragen - Anzeige der gewählten Abfrage
    $('body').on('change', '.tt-select-monitoring', function (e) {

        checkCustomMonitoringEnterValuesLater().done(function (hasEnterValuesLater) {

            if (!hasEnterValuesLater) {
                setTableData();
            }
        });
    });

    // Abfragen Admin - Anzuzeigendes Feld/Einschränkung auswählen
    $('body').on('click', '.tt-monitoring-dd3-content', function (e) {

        $(this).parents('.dd-list').find('.dd3-content').removeClass('dd-content-active');
        $(this).addClass('dd-content-active');

        $(this).parents('.tt-content-datatable').find('.tt-delete-monitoring-nestable').removeClass('disabled');
        $(this).parents('.tt-content-datatable').find('[name="selected_monitoring_nestable_id"]').val($(this).data().id);
    });

    // Abfragen Admin - Ausgewählte Einschränkung in Dialog anzeigen (keine Operatoren)
    $('body').on('dblclick', '.tt-monitoring-dd3-content', function (e) {
        e.preventDefault();

        var table = $(this).parents('.tt-content-datatable').find('.tripletrax-scroll-panel');
        if (table.length && table[0].id === "monitoring_restrictions_table") {

            var viewName = $(this).data().viewName;
            if (viewName !== 'and' && viewName !== 'and_concurrent' && viewName !== 'or' && viewName !== 'left_parenthesis' && viewName !== 'right_parenthesis') {

                var form = $('#table_monitoring_types_restriction_form');
                if (!$('#table_monitoring_types_restriction_form').length) {
                    form = $('#table_monitoring_restriction_create_form');
                }
                setMonitoringRestrictionSavedValues(form, $(this).data(), $('#table_monitoring_types_restriction_form').length);
                form.find('[name="selected_id"]').val($(this).data().id);

                $(this).parents('.tt-content-detail').find('.tt-add-monitoring-restriction').click();
            }
        }
    });

    // Abfragen Admin - Anzuzeigendes Feld/Einschränkung löschen
    $('body').on('click', '.tt-delete-monitoring-nestable', function (e) {
        e.preventDefault();

        var element = $(this);
        var table = element.parents('.tt-content-datatable').find('.tripletrax-scroll-panel');
        var id = element.parents('.tt-content-datatable').find('[name="selected_monitoring_nestable_id"]').val();
        var contentElement = element.parents('.tt-content-datatable').find('[data-id="' + id + '"]');
        var title = '';
        var content = '';

        if (table.length) {
            if (table[0].id === "monitoring_display_fields_table") {
                if (!utils.isUndefined(contentElement)) {
                    title = "<i class='fad fa-trash-alt txt-color-orangeDark'></i>  " + Lang.get('tripletrax.delete_monitoring_display_field', {"field": "<span class='txt-color-orangeDark'><strong>" + contentElement[0].innerText + "</strong></span>"});
                    content = Lang.get('tripletrax.delete_monitoring_display_field_desc');
                }
            } else if (table[0].id === "monitoring_restrictions_table") {
                if (!utils.isUndefined(contentElement)) {
                    title = "<i class='fad fa-trash-alt txt-color-orangeDark'></i>  " + Lang.get('tripletrax.delete_monitoring_restriction', {"restriction": "<span class='txt-color-orangeDark'><strong>" + contentElement[0].innerText + "</strong></span>"});
                    content = Lang.get('tripletrax.delete_monitoring_restriction_desc');
                }
            }
        }

        $.SmartMessageBox({
            title: title,
            content: content,
            buttons: '[' + Lang.get('tripletrax.no') + '][' + Lang.get('tripletrax.yes') + ']'
        }, function (ButtonPressed) {
            if (ButtonPressed === Lang.get('tripletrax.yes')) {

                if ($(table).parents('.tt-content-detail').find('.tt-datatable-changes').val() !== 'changed') {
                    $(table).parents('.tt-content-detail').find('.tt-datatable-changes').val('changed');
                    $(table).parents('.tt-content-detail').find('form').trigger('checkform.areYouSure');
                }

                contentElement.data('isDeleted', true);
                contentElement.parents('.dd-item').addClass('hide');
                contentElement.addClass('tt-deleted-monitoring-nestable');

                element.parents('.tt-content-datatable').find('.tt-delete-monitoring-nestable').addClass('disabled');
            }
        });
    });

    // Abfragen Admin - Operator "&" hinzufügen
    $('body').on('click', '.tt-add-monitoring-operator-and', function (e) {
        e.preventDefault();

        addNewMonitoringOperator('&');
    });

    // Abfragen Admin - Operator "&&" hinzufügen
    $('body').on('click', '.tt-add-monitoring-operator-and-concurrent', function (e) {
        e.preventDefault();

        addNewMonitoringOperator('&&');
    });

    // Abfragen Admin - Operator "|" hinzufügen
    $('body').on('click', '.tt-add-monitoring-operator-or', function (e) {
        e.preventDefault();

        addNewMonitoringOperator('|');
    });

    // Abfragen Admin - Operator "(" hinzufügen
    $('body').on('click', '.tt-add-monitoring-operator-left-parenthesis', function (e) {
        e.preventDefault();

        addNewMonitoringOperator('(');
    });

    // Abfragen Admin - Operator ")" hinzufügen
    $('body').on('click', '.tt-add-monitoring-operator-right-parenthesis', function (e) {
        e.preventDefault();

        addNewMonitoringOperator(')');
    });

    // Abfragen Admin - Feld der Einschränkung ändern (Anzeige der dazugehörigen Felder)
    $('body').on('change', '[name="monitoring_restriction_data_view_field"]', function (e) {

        if (!utils.isUndefined($(this).select2('val')) && $(this).select2('val') !== '') {
            $('#table_monitoring_restrictions_dialog').find('[name="control_type"]').val($(this).select2('data')[0].controlType);
            $('#table_monitoring_restrictions_dialog').find('[name="data_type"]').val($(this).select2('data')[0].dataType);
            $('#table_monitoring_restrictions_dialog').find('[name="is_course_field"]').val($(this).select2('data')[0].isCourseField);
        } else {
            $('#table_monitoring_restrictions_dialog').find('[name="control_type"]').val('');
            $('#table_monitoring_restrictions_dialog').find('[name="data_type"]').val('');
            $('#table_monitoring_restrictions_dialog').find('[name="is_course_field"]').val('');
        }

        // Felder zurücksetzen
        $(this).parents('form').find('.tt-monitoring-restriction-specific-values').find('input[type="hidden"]').val("");
        $(this).parents('form').find('.tt-monitoring-restriction-specific-values').find('input:not([type="radio"])').val("");
        if ($(this).parents('form').find('.tt-monitoring-restriction-specific-values').find('.datepicker').length) {
            $(this).parents('form').find('.tt-monitoring-restriction-specific-values').find('.datepicker').data('picker').setDate(null);
        }
        $(this).parents('form').find('.tt-monitoring-restriction-specific-values').find('[type="radio"],[type="checkbox"]').prop('checked', false);
        $(this).parents('form').find('.tt-monitoring-restriction-specific-values').find('.tt-select2').val(null).trigger('change.select2');
        $(this).parents('form').find('.tt-monitoring-restriction-specific-values').find('.tt-select2').removeAttr('disabled');

        $(this).parents('form').find('.tt-monitoring-restriction-specific-values').find('.dropdown-toggle:not([name="monitoring_restriction_field_value_till_dropdown_toggle"],[name="monitoring_restriction_field_value_till_date_dropdown_toggle"])').prop('disabled', '');
        $(this).parents('form').find('.tt-monitoring-restriction-specific-values').find('input:not([type="radio"],[type="checkbox"],[name="monitoring_restriction_field_value_till"],[name="monitoring_restriction_field_value_till_date_range"],[name="monitoring_restriction_field_value_till_date"],.tt-disabled-monitoring-restriction-select2)').prop('disabled', '');
        $(this).parents('form').find('.tt-monitoring-restriction-specific-values').find('input:not([type="radio"],[type="checkbox"],[name="monitoring_restriction_field_value_till"],[name="monitoring_restriction_field_value_till_date_range"],[name="monitoring_restriction_field_value_till_date"],.tt-disabled-monitoring-restriction-select2)').parent().removeClass('state-disabled');
        $(this).parents('form').find('.tt-monitoring-restriction-specific-values').find('.tt-select2:not(.tt-disabled-monitoring-restriction-select2)').prop('disabled', '');
        $(this).parents('form').find('.tt-monitoring-restriction-specific-values').find('[type="checkbox"]:not([name="monitoring_restriction_not_existing_value"],[name="monitoring_restriction_existing_value"],[name="monitoring_restriction_field_value_till_plus_minus"],[name="monitoring_restriction_period_value_till_plus_minus"])').prop('disabled', '');
        $(this).parents('form').find('.tt-monitoring-restriction-specific-values').find('[type="radio"]').prop('disabled', false);

        jQuery.each($(this).parents('form').find('.tt-monitoring-restriction-specific-values').find('.tt-date-dropdown'), function (i, val) {
            utils.setValueForInputWithDropDownField($(val).parent(), 'years', true);
        });

        // inaktive Felder neu setzen

        // Feld (Input)
        if ($(this).parents('form').find('.tt-field-input-numeric').length) {
            $(this).parents('form').find('.tt-field-input-numeric').find('[name="monitoring_restriction_field_logical_till_numeric_field"]').prop('disabled', 'disabled');
            $(this).parents('form').find('.tt-field-input-numeric').find('[name="monitoring_restriction_field_value_till"]').prop('disabled', 'disabled');
            $(this).parents('form').find('.tt-field-input-numeric').find('[name="monitoring_restriction_field_value_till"]').parent().addClass('state-disabled');
            $(this).parents('form').find('.tt-field-input-numeric').find('[name="monitoring_restriction_field_value_till_dropdown_toggle"]').prop('disabled', 'disabled');
            $(this).parents('form').find('.tt-field-input-numeric').find('[name="monitoring_restriction_field_value_till_field"]').prop('disabled', 'disabled');
            $(this).parents('form').find('.tt-field-input-numeric').find('[name="monitoring_restriction_later_field_value_till"]').prop('disabled', 'disabled');
        }

        // Feld (Datum)
        if ($(this).parents('form').find('.tt-field-date').length) {
            $(this).parents('form').find('.tt-field-date').find('[name="monitoring_restriction_field_logical_till_date_field"]').prop('disabled', 'disabled');
            $(this).parents('form').find('.tt-field-date').find('[name="monitoring_restriction_field_value_till_date"]').prop('disabled', 'disabled');
            $(this).parents('form').find('.tt-field-date').find('[name="monitoring_restriction_field_value_till_date"]').parent().addClass('state-disabled');
            $(this).parents('form').find('.tt-field-date').find('[name="monitoring_restriction_field_value_till_date_field"]').prop('disabled', 'disabled');
            $(this).parents('form').find('.tt-field-date').find('[name="monitoring_restriction_field_value_till_date_range"]').parent().addClass('state-disabled');
            $(this).parents('form').find('.tt-field-date').find('[name="monitoring_restriction_field_value_till_date_dropdown_toggle"]').prop('disabled', 'disabled');
            $(this).parents('form').find('.tt-field-date').find('[name="monitoring_restriction_field_value_till_date_range"]').prop('disabled', 'disabled');
            $(this).parents('form').find('.tt-field-date').find('[name="monitoring_restriction_field_value_till_plus_minus"]').prop('disabled', 'disabled');
            $(this).parents('form').find('.tt-field-date').find('[name="monitoring_restriction_later_till_date"]').prop('disabled', 'disabled');
        }

        // Darstellungszeitraum
        if ($(this).parents('form').find('.tt-period-restriction').length) {
            $(this).parents('form').find('.tt-period-restriction').find('[name="monitoring_restriction_period_logical_till"]').prop('disabled', 'disabled');
            $(this).parents('form').find('.tt-period-restriction').find('[name="monitoring_restriction_period_value_till"]').prop('disabled', 'disabled');
            $(this).parents('form').find('.tt-period-restriction').find('[name="monitoring_restriction_period_value_till"]').parent().addClass('state-disabled');
            $(this).parents('form').find('.tt-period-restriction').find('[name="monitoring_restriction_period_value_till_field"]').prop('disabled', 'disabled');
            $(this).parents('form').find('.tt-period-restriction').find('[name="monitoring_restriction_period_value_till_date_range"]').parent().addClass('state-disabled');
            $(this).parents('form').find('.tt-period-restriction').find('[name="monitoring_restriction_period_value_till_date_dropdown_toggle"]').prop('disabled', 'disabled');
            $(this).parents('form').find('.tt-period-restriction').find('[name="monitoring_restriction_period_value_till_date_range"]').prop('disabled', 'disabled');
            $(this).parents('form').find('.tt-period-restriction').find('[name="monitoring_restriction_period_value_till_plus_minus"]').prop('disabled', 'disabled');
            $(this).parents('form').find('.tt-period-restriction').find('[name="monitoring_restriction_later_period_value_till"]').prop('disabled', 'disabled');
        }

        // Auswahllisten neu befüllen
        var control_type = '';
        var control_type_values = '';
        var units = '';
        var format_fields = '';
        var table_type = '';
        var table = '';

        if (!utils.isUndefined($(this).select2('val')) && $(this).select2('val') !== '') {
            control_type = $(this).select2('data')[0].controlType;
            control_type_values = $(this).select2('data')[0].controlValues;
            units = $(this).select2('data')[0].units;
            format_fields = $(this).select2('data')[0].formatFields.split('|');
            table_type = $(this).select2('data')[0].tableType;
            table = $(this).select2('data')[0].table;
        }

        var fieldTableType = '';
        if (table_type === 'master_table' || table_type === 'master_facility_table') {
            fieldTableType = 'master';
        } else if (table_type === 'course_table' || table_type === 'course_facility_table') {
            fieldTableType = 'course';
        } else if (table_type === 'period_table' || table_type === 'period_facility_table') {
            fieldTableType = 'period_' + table;
        }

        loadMonitoringRestrictionComboboxValues(control_type, control_type_values, units, format_fields);
        setMonitoringRestrictionComboboxItems($(this).parents('form'), fieldTableType, false);

        showMonitoringRestrictionSpecificFieldsOfValue(this);
    });

    // Abfragen Admin - Anhaken von 'Wert vorhanden'
    $('body').on('change', '.tt-monitoring-restriction-existing-value', function (e) {
        if ($(this)[0].checked) {

            // Werte zurücksetzen
            $(this).parents('form').find('.tt-field-values').find('input[type="hidden"]').val("");
            $(this).parents('form').find('.tt-field-values').find('input:not([type="radio"])').val("");
            if ($(this).parents('form').find('.tt-field-values').find('.datepicker').length) {
                $(this).parents('form').find('.tt-field-values').find('.datepicker').data('picker').setDate(null);
            }
            $(this).parents('form').find('.tt-field-values').find('[type="radio"],[type="checkbox"]:not([name="monitoring_restriction_existing_value"])').prop('checked', false);
            $(this).parents('form').find('.tt-field-values').find('.tt-select2').val(null).trigger('change.select2');
            jQuery.each($(this).parents('form').find('.tt-field-values').find('.tt-date-dropdown'), function (i, val) {
                utils.setValueForInputWithDropDownField($(val).parent(), 'years', true);
            });
        }

        setMonitoringRestrictionDependingFieldsOfValue(this);
    });

    // Abfragen Admin - Anhaken von 'Wert nicht vorhanden'
    $('body').on('change', '.tt-monitoring-restriction-not-existing-value', function (e) {
        if ($(this)[0].checked) {

            // Werte zurücksetzen
            $(this).parents('form').find('.tt-field-values').find('input[type="hidden"]').val("");
            $(this).parents('form').find('.tt-field-values').find('input:not([type="radio"])').val("");
            if ($(this).parents('form').find('.tt-field-values').find('.datepicker').length) {
                $(this).parents('form').find('.tt-field-values').find('.datepicker').data('picker').setDate(null);
            }
            $(this).parents('form').find('.tt-field-values').find('[type="radio"],[type="checkbox"]:not([name="monitoring_restriction_not_existing_value"])').prop('checked', false);
            $(this).parents('form').find('.tt-field-values').find('.tt-select2').val(null).trigger('change.select2');
            jQuery.each($(this).parents('form').find('.tt-field-values').find('.tt-date-dropdown'), function (i, val) {
                utils.setValueForInputWithDropDownField($(val).parent(), 'years', true);
            });
        }

        setMonitoringRestrictionDependingFieldsOfValue(this);
    });

    // Abfragen Admin - Ändern von 'Wert (Feld)' (Input und Datepanel)
    $('body').on('change', '.tt-monitoring-restriction-deviation-value-field', function (e) {
        var parent_class = '';
        jQuery.each($(this).parents(), function (i, parent) {
            if (parent.classList.length) {
                jQuery.each(parent.classList, function (i, current_class) {
                    if (/^tt-/.test(current_class)) {
                        parent_class = current_class;
                        return false;
                    }
                });
            }
            if (parent_class !== '') {
                return false;
            }
        });

        setMonitoringRestrictionValueTill(this, '.' + parent_class);
    });

    // Abfragen Admin - Logik-Auswahl für den Bis-Bereich neu setzen
    $('body').on('change', '.tt-monitoring-restriction-logical-from', function (e) {

        setMonitoringRestrictionFieldsDependingOnLogicalOperator(this);
    });

    // Abfragen Admin - Einheit für den Von- bzw. Bis-Bereich gleich setzen
    $('body').on('click', '.tt-select-monitoring-restriction-unit-value', function (e) {
        e.preventDefault();

        utils.setInputDropDownValue($(this).parents('.tt-field-input-numeric').find('.tt-select-monitoring-restriction-unit-value[data-format-value="' + $(this).data('formatValue') + '"]')[0], true);
        utils.setInputDropDownValue($(this).parents('.tt-field-input-numeric').find('.tt-select-monitoring-restriction-unit-value[data-format-value="' + $(this).data('formatValue') + '"]')[1], true);

        if ($(this).parents('.display-flex').find('.datepicker,.treelist-input').length > 0) {
            validator.triggerValidation($(this).parents('.display-flex').find('.datepicker,.treelist-input')[0], true, false);
        }
    });

    // Abfragen Admin - Anhaken von 'später eintragbar'
    $('body').on('change', '.tt-monitoring-later-value', function (e) {
        if ($(this)[0].checked) {

            // Werte zurücksetzen
            $(this).parents('.tt-monitoring-restriction-row-specific-values').find('input:not([type="radio"],.tt-monitoring-restriction-logical-operator,.datepicker)').val("");
            if ($(this).parents('.tt-monitoring-restriction-row-specific-values').find('.datepicker').length) {
                $(this).parents('.tt-monitoring-restriction-row-specific-values').find('.datepicker').data('picker').setDate(null);
            }
            $(this).parents('.tt-monitoring-restriction-row-specific-values').find('[type="radio"],[type="checkbox"]:not([name="' + $(this)[0].name + '"])').prop('checked', false);
            $(this).parents('.tt-monitoring-restriction-row-specific-values').find('.tt-select2:not(.tt-monitoring-restriction-logical-operator)').val(null).trigger('change.select2');
            jQuery.each($(this).parents('.tt-monitoring-restriction-row-specific-values').find('.tt-date-dropdown'), function (i, val) {
                utils.setValueForInputWithDropDownField($(val).parent(), 'years', true);
            });
        }

        // Felder inaktiv setzen
        $(this).parents('.tt-monitoring-restriction-row-specific-values').find('.dropdown-toggle').prop('disabled', 'disabled');
        $(this).parents('.tt-monitoring-restriction-row-specific-values').find('input:not([type="checkbox"],.tt-monitoring-restriction-logical-operator)').prop('disabled', 'disabled');
        $(this).parents('.tt-monitoring-restriction-row-specific-values').find('input:not([type="checkbox"],.tt-monitoring-restriction-logical-operator)').parent().addClass('state-disabled');
        $(this).parents('.tt-monitoring-restriction-row-specific-values').find('.tt-select2:not(.tt-monitoring-restriction-logical-operator)').prop('disabled', 'disabled');
        $(this).parents('.tt-monitoring-restriction-row-specific-values').find('[type="checkbox"]:not([name="' + $(this)[0].name + '"])').prop('disabled', 'disabled');

        if (!$(this)[0].checked) {
            // Felder wieder aktiv setzen
            $(this).parents('.tt-monitoring-restriction-row-specific-values').find('.dropdown-toggle').prop('disabled', '');
            $(this).parents('.tt-monitoring-restriction-row-specific-values').find('input:not([type="radio"],[type="checkbox"],.tt-monitoring-restriction-logical-operator)').prop('disabled', '');
            $(this).parents('.tt-monitoring-restriction-row-specific-values').find('input:not([type="radio"],[type="checkbox"],.tt-monitoring-restriction-logical-operator)').parent().removeClass('state-disabled');
            $(this).parents('.tt-monitoring-restriction-row-specific-values').find('.tt-select2:not(.tt-monitoring-restriction-logical-operator)').prop('disabled', '');
            $(this).parents('.tt-monitoring-restriction-row-specific-values').find('[type="checkbox"]:not([name="' + $(this)[0].name + '"])').prop('disabled', '');
            $(this).parents('.tt-monitoring-restriction-row-specific-values').find('[type="radio"]').prop('disabled', false);
        }
    });

    // Export der Abfragen-Ergebnisliste
    $('body').on('click', '.tt-export-monitoring-result', function (e) {
        e.preventDefault();

        var form = $(this).parents('form')[0];

        $(form).find('.tt-please-wait-export').removeClass('hide');
        $(form).find('.tt-export-monitoring-result').prop('disabled', 'disabled');
        $(form).find('.tt-export-monitoring-result').addClass('disabled');

        $(form).find('[name="export_time_stamp"]').val($.now());
        var exportFormat = $(this).parents('form').find('[name="export_format"]:checked').val();
        var fileFormat = $(this).parents('form').find('[name="file_format"]:checked').val();
        var monitoringId = $(this).parents('form').find('.tt-select-monitoring').select2('val');
        monitoringId = monitoringId.substr(monitoringId.lastIndexOf('/') + 1);

        var selectedTabs = '';
        if (exportFormat === 'selection') {
            jQuery.each($('.tt-selection-tab:checked'), function(i, element) {
                if (selectedTabs !== '') {
                    selectedTabs += '|';
                }
                selectedTabs += element.name;
            });
        }
        if (exportFormat === 'selection' && selectedTabs === '') {
            $.SmartMessageBox({
                title: "<i class='fad fa-exclamation-triangle txt-color-orangeDark'></i>  " + Lang.get('tripletrax.missing_selection_tabs'),
                content: Lang.get('tripletrax.missing_selection_tabs_desc'),
                buttons: '[' + Lang.get('tripletrax.ok') + ']'
            }, function (ButtonPressed) {
                $(form).find('.tt-please-wait-export').addClass('hide');
                $(form).find('.tt-export-monitoring-result').removeAttr('disabled');
                $(form).find('.tt-export-monitoring-result').removeClass('disabled');
            });
        } else {
            if (exportFormat === 'table' && monitoringId === 'patientlist') {

                var exportArray = [];
                var allTableData = $(this).parents('form').find('table').DataTable().data().toArray();
                jQuery.each(allTableData, function (i, line) {
                    var exportLine = [];
                    exportLine.push(line.pseudonym);
                    exportLine.push(line.patientname);
                    exportLine.push(line.prename);
                    exportLine.push(line.street);
                    exportLine.push(line.postal_code);
                    exportLine.push(line.city);
                    exportLine.push(line.birth_date_display);
                    exportLine.push(line.agreements_display);
                    exportLine.push(line.state_aggregate_display);
                    exportArray.push(exportLine);
                });
                validator.openWindow('doc/patient/monitoring/download_table/', 'POST', {table_data: JSON.stringify(exportArray), file_extension: fileFormat, monitoring_id: monitoringId}, '_blank', $('[name="csrf-token"]').attr('content'));

                // Export-Button wieder aktiv setzen
                $('#content').find('.tt-save,.tt-export-monitoring-result').removeClass('disabled');
                $('#content').find('.tt-save,.tt-export-monitoring-result').prop('disabled', '');

                $('.tt-please-wait-export').addClass('hide');
            } else {

                var tableData = $(this).parents('form').find('table').DataTable().column(0).data().toArray().join('|');
                var originalData = 'table_data=' + tableData + '&file_format=' + fileFormat + '&export_format=' + exportFormat + '&selected_tabs=' + selectedTabs + '&monitoring_id=' + monitoringId + '&export_time_stamp=' + $(form).find('[name="export_time_stamp"]').val();

                ajax.ajaxCall('doc/patient/monitoring/export', 'POST', originalData, false, function (data) {

                    $(form).attr('action', 'admin/export/export/0');
                    validator.doExport(form, data, originalData);
                });
            }
        }
    });

    // RadioButton - Wert löschen
    $('body').on('click', '.tt-btn-monitoring-eraser', function (e) {

        var control = $($(this).parents('section')[0]).find('[name="' + this.dataset.control + '"]');
        if (control.is(':radio')) {
            control = $($(this).parents('section')[0]).find('[name="' + this.dataset.control + '"]:checked');
            control.prop('checked', false);
        }
    });

    $('body').on('select2:select', '[name="monitoring_restriction_mutation1"],[name="monitoring_restriction_mutation2"]', function (e) {

        if (!utils.isUndefined(e.params.data) && ($(e.params.data.element).data().match === 'not_F508del')) {
            $(this).val([e.params.data.id]).trigger('change.select2');
        } else {
            var select_array = [];
            jQuery.each($(this).select2('data'), function (i, val) {
                if ($(val.element).data().match !== 'not_F508del') {
                    select_array.push(val.id);
                }
            });
            $(this).val(select_array).trigger('change.select2');
        }
    });

    $('body').on('change', '[name="monitoring_restriction_default_lung_function"]', function (e) {
        e.preventDefault();

        if ($('[name="monitoring_restriction_default_lung_function"]:checked').val() === 'gli_2012') {
            $('.tt-fev1-norm').addClass('hide');
            $('.tt-fev1-norm-gli-2012').removeClass('hide');
        } else {
            $('.tt-fev1-norm-gli-2012').addClass('hide');
            $('.tt-fev1-norm').removeClass('hide');
        }
    });

	$('body').on('change', '[name="monitoring_restriction_default_percentile_function"]', function (e) {
		e.preventDefault();

		if ($('[name="monitoring_restriction_default_percentile_function"]:checked').val() === 'kiggs') {
			$('.tt-bmi-percentile').addClass('hide');
			$('.tt-bmi-percentile-kiggs').removeClass('hide');
		} else {
			$('.tt-bmi-percentile-kiggs').addClass('hide');
			$('.tt-bmi-percentile').removeClass('hide');
		}
	});
}

function setTableData() {

    if ($('.tt-select-monitoring').length && !utils.isUndefined($('.tt-select-monitoring').select2('val')) && $('.tt-select-monitoring').select2('val') !== '') {

        var selectedMonitoring = $('.tt-select-monitoring').select2('val');
        ajax.ajaxCall(selectedMonitoring, 'GET', null, false, function (data) {

            utils.setHtmlData($('#content-detail'), data, true);
        });
    } else {
        $('#content-detail').empty();
    }
}

function addNewMonitoringOperator(operator) {

    var counter = -1;
    jQuery.each($('#monitoring_restrictions_table').find('.dd3-content'), function (i, val) {
        if ($(val).data('id') < 0) {
            counter = counter - 1;
        }
    });

    var text = '';
    var dataViewName = '';

    if (operator === '&') {
        text = Lang.get('tripletrax.and');
        dataViewName = 'and';
    } else if (operator === '&&') {
        text = Lang.get('tripletrax.and_concurrent');
        dataViewName = 'and_concurrent';
    } else if (operator === '|') {
        text = Lang.get('tripletrax.or');
        dataViewName = 'or';
    } else if (operator === '(') {
        text = '(';
        dataViewName = 'left_parenthesis';
    } else if (operator === ')') {
        text = ')';
        dataViewName = 'right_parenthesis';
    }

    var html = '';
    var item = $('#monitoring_restrictions_table').find('.dd-list')[0];

    html += '<li class="dd-item dd3-item">';
    html += '   <div class="dd-handle dd-dialog-handle dd3-handle">';
    html += '   </div>';
    html += '   <div class="dd3-content dd-dialog-content tt-monitoring-dd3-content" data-id="' + counter + '" data-view-id="-1" data-view-name="' + dataViewName + '" data-description="Operator" data-value="" data-range-of-values="" data-unit="" data-value-from-logical-operator="" data-value-from-string="" data-value-from-decimal="" data-value-from-date="" data-value-from-view-id="" data-value-from-view-name="" data-value-from-up-down="" data-value-from-value="" data-value-from-range="" data-value-till-logical-operator="" data-value-till-decimal="" data-value-till-date="" data-value-till-view-id="" data-value-till-view-name="" data-value-till-up-down="" data-value-till-value="" data-value-till-range="" data-period-from-logical-operator="" data-period-from-date="" data-period-till-logical-operator="" data-period-till-date="" data-value-from-later="" data-value-till-later="" data-period-from-later="" data-period-till-later="" data-period-from-view-id="" data-period-from-view-name="" data-period-from-up-down="" data-period-from-value="" data-period-from-range="" data-period-till-view-id="" data-period-till-view-name="" data-period-till-up-down="" data-period-till-value="" data-period-till-range="" data-is-deleted="false">';
    html += '       <label class="dd3-content-label">' + text + '</label>';
    html += '   </div>';
    html += '</li>';

    $(html).appendTo(item);

    $('#monitoring_restrictions_table').parents('.tt-content-datatable').find('.tt-delete-monitoring-nestable').addClass('disabled');
    if ($('#monitoring_restrictions_table').parents('.tt-content-detail').find('.tt-datatable-changes').val() !== 'changed') {
        $('#monitoring_restrictions_table').parents('.tt-content-detail').find('.tt-datatable-changes').val('changed');
        $('#monitoring_restrictions_table').parents('.tt-content-detail').find('form').trigger('checkform.areYouSure');
    }
}

function setMonitoringRestrictionComboboxItems(form, tableTypeName, doLoadDataViewFields) {

    if (doLoadDataViewFields) {
        setMonitoringRestrictionFieldSelection('monitoring_restriction_data_view_field', 'all_fields', 'tt-monitoring-restriction-field', form);
    }

    setMonitoringRestrictionFieldSelection('monitoring_restriction_field_value_from_date_field', 'date_fields_' + tableTypeName, 'tt-monitoring-restriction-field tt-monitoring-restriction-deviation-value-field validation-group-range-date-from', form);
    setMonitoringRestrictionFieldSelection('monitoring_restriction_field_value_till_date_field', 'date_fields_' + tableTypeName, 'tt-monitoring-restriction-field tt-monitoring-restriction-deviation-value-field tt-disabled-monitoring-restriction-select2 validation-group-range-date-till', form);
    setMonitoringRestrictionFieldSelection('monitoring_restriction_field_value_from_field', 'number_fields_' + tableTypeName, 'tt-monitoring-restriction-field tt-monitoring-restriction-deviation-value-field validation-group-range-input-from', form);
    setMonitoringRestrictionFieldSelection('monitoring_restriction_field_value_till_field', 'number_fields_' + tableTypeName, 'tt-monitoring-restriction-field tt-monitoring-restriction-deviation-value-field tt-disabled-monitoring-restriction-select2 validation-group-range-input-till', form);
    setMonitoringRestrictionFieldSelection('monitoring_restriction_period_value_from_field', 'date_fields_' + tableTypeName, 'tt-monitoring-restriction-field tt-monitoring-restriction-deviation-value-field validation-group-period-date-from', form);
    setMonitoringRestrictionFieldSelection('monitoring_restriction_period_value_till_field', 'date_fields_' + tableTypeName, 'tt-monitoring-restriction-field tt-monitoring-restriction-deviation-value-field tt-disabled-monitoring-restriction-select2 validation-group-period-date-till', form);
}

function setMonitoringRestrictionFieldSelection(name, inputName, classString, form) {
    var monitoringRestrictionDataViewField = $(form).find('[name="' + name + '"]').parent();

    if (monitoringRestrictionDataViewField.length) {
        var data_range = '';
        var data_range_string = '';
        if ($(form).find('[name="' + name + '"]').length) {
            if (/data-range=/.test($(form).find('[name="' + name + '"]')[0].outerHTML)) {
                data_range = $($(form).find('[name="' + name + '"]'))[0].outerHTML.substr($(form).find('[name="' + name + '"]')[0].outerHTML.indexOf('data-range=') + 12, 4);
                data_range_string = ' data-range="' + data_range + '"';
            }
        }

        var data = [];

        if (/^date_fields_/.test(inputName)) {
            data.push({ id: '-1|now', text: Lang.get('tripletrax.today'), controlType: '', dataType: '', controlValues: '', additionalField: '', units: '', range: data_range, formatFields: '', matchField: '', isCourseField: '', table: '' });
        }

        if (inputName !== '' && $('#' + inputName + '').length) {
            $.each($.parseJSON($('#' + inputName + '').val()), function (index, field) {
                data.push({
                    id: field.id + '|' + field.name,
                    text: field.desc + ' (' + field.name + ')',
                    controlType: field.control_type,
                    dataType: field.data_type,
                    controlValues: field.control_values,
                    additionalField: field.additional_field,
                    units: field.units,
                    range: data_range,
                    formatFields: field.format_fields,
                    tableType: field.table_type,
                    matchField: field.match_field,
                    isCourseField: field.is_course_field,
                    table: field.table
                });
            });
        }

        validator.reinitializeSelect2($(monitoringRestrictionDataViewField), 'input-sm tt-select2 ' + classString, data_range_string, data, false);
    }
}

function showMonitoringRestrictionSpecificFieldsOfValue(element) {

    $(element).parents('form').find('.tt-monitoring-restriction-separator').addClass('hide');
    $(element).parents('form').find('.tt-monitoring-restriction-specific-values').addClass('hide');
    $(element).parents('form').find('.tt-period-restriction').addClass('hide');

    var control_type = $(element).parents('.tt-content-dialog').find('[name="control_type"]').val();
    var data_type = $(element).parents('.tt-content-dialog').find('[name="data_type"]').val();
    var is_course_field = $(element).parents('.tt-content-dialog').find('[name="is_course_field"]').val();

    if (control_type !== '') {
        $(element).parents('form').find('.tt-monitoring-restriction-separator').removeClass('hide');
        $(element).parents('form').find('.tt-monitoring-restriction-specific-values').removeClass('hide');

        $(element).parents('form').find('.tt-field-date').addClass('hide');
        $(element).parents('form').find('.tt-field-list').addClass('hide');
        $(element).parents('form').find('.tt-field-input').addClass('hide');
        $(element).parents('form').find('.tt-field-input-numeric').addClass('hide');
        $(element).parents('form').find('.tt-monitoring-restriction-or').removeClass('hide');

        if (control_type === 'input' || control_type === 'input_with_additionalfield' || control_type === 'textarea') {
            if (data_type === 'integer' || data_type === 'decimal') {
                $(element).parents('form').find('.tt-field-input-numeric').removeClass('hide');
            } else {
                $(element).parents('form').find('.tt-field-input').removeClass('hide');
            }
        } else if (control_type === 'date_panel' || control_type === 'date_range') {
            $(element).parents('form').find('.tt-field-date').removeClass('hide');
        } else if (control_type === 'checkbox') {
            $(element).parents('form').find('.tt-monitoring-restriction-or').addClass('hide');
        } else {
            $(element).parents('form').find('.tt-field-list').removeClass('hide');
        }
    }

    if (is_course_field === '1') {
        $(element).parents('form').find('.tt-period-restriction').removeClass('hide');
    }

    $(element).parents('form').validate().settings.rules = validator.getRules($(element).parents('form'));
}

function setMonitoringRestrictionDependingFieldsOfValue(element) {
    // Felder inaktiv setzen
    $(element).parents('form').find('.tt-field-values').find('.dropdown-toggle').prop('disabled', 'disabled');
    $(element).parents('form').find('.tt-field-values').find('input:not([type="checkbox"])').prop('disabled', 'disabled');
    $(element).parents('form').find('.tt-field-values').find('input:not([type="checkbox"])').parent().addClass('state-disabled');
    $(element).parents('form').find('.tt-field-values').find('.tt-select2').prop('disabled', 'disabled');
    $(element).parents('form').find('.tt-field-values').find('[type="checkbox"]:not([name="monitoring_restriction_not_existing_value"],[name="monitoring_restriction_existing_value"])').prop('disabled', 'disabled');

    if (!$(element)[0].checked) {
        // Felder wieder aktiv setzen
        $(element).parents('form').find('.tt-field-values').find('.dropdown-toggle:not([name="monitoring_restriction_field_value_till_dropdown_toggle"],[name="monitoring_restriction_field_value_till_date_dropdown_toggle"])').prop('disabled', '');
        $(element).parents('form').find('.tt-field-values').find('input:not([type="radio"],[type="checkbox"],[name="monitoring_restriction_field_value_till"],[name="monitoring_restriction_field_value_till_date_range"],[name="monitoring_restriction_field_value_till_date"],.tt-disabled-monitoring-restriction-select2)').prop('disabled', '');
        $(element).parents('form').find('.tt-field-values').find('input:not([type="radio"],[type="checkbox"],[name="monitoring_restriction_field_value_till"],[name="monitoring_restriction_field_value_till_date_range"],[name="monitoring_restriction_field_value_till_date"],.tt-disabled-monitoring-restriction-select2)').parent().removeClass('state-disabled');
        $(element).parents('form').find('.tt-field-values').find('.tt-select2:not(.tt-disabled-monitoring-restriction-select2)').prop('disabled', '');
        $(element).parents('form').find('.tt-field-values').find('[type="checkbox"]:not([name="monitoring_restriction_not_existing_value"],[name="monitoring_restriction_existing_value"],[name="monitoring_restriction_field_value_till_plus_minus"],[name="monitoring_restriction_later_till_date"],[name="monitoring_restriction_later_field_value_till"],[name="monitoring_restriction_period_value_till_plus_minus"],[name="monitoring_restriction_later_period_value_till"])').prop('disabled', '');
        $(element).parents('form').find('.tt-field-values').find('[type="radio"]').prop('disabled', false);
    }
}

function setMonitoringRestrictionFieldsDependingOnLogicalOperator(element) {
    var selected_from_value = $(element).select2('val');

    // Auswahlliste mit Logik-Operatoren befüllen
    var data = [];

    if (selected_from_value === '') {
        data.push({ id: '>=', text: '>=' });
        data.push({ id: '>', text: '>' });
        data.push({ id: '<=', text: '<=' });
        data.push({ id: '<', text: '<' });
        data.push({ id: '=', text: '=' });
        data.push({ id: '!=', text: '!=' });
    } else if (selected_from_value === '>=' || selected_from_value === '>') {
        data.push({ id: '<=', text: '<=' });
        data.push({ id: '<', text: '<' });
    } else if (selected_from_value === '<=' || selected_from_value === '<') {
        data.push({ id: '>=', text: '>=' });
        data.push({ id: '>', text: '>' });
    }

    var select_class = $(element).data().logicClass;

    validator.reinitializeSelect2($('.' + select_class).parent(), 'tt-select2 select2-container tt-monitoring-restriction-logical-operator ' + select_class + ' tt-disabled-monitoring-restriction-select2', 'data-range="till"', data, false, true);

    if (selected_from_value === '=' || selected_from_value === '!=' || selected_from_value === '' || utils.isUndefined((selected_from_value))) {

        // Feld (Input)
        if ($(element).parents('.tt-field-input-numeric').length) {
            $(element).parents('.tt-field-input-numeric').find('[name="monitoring_restriction_field_logical_till_numeric_field"]').val(null).trigger('change.select2');
            $(element).parents('.tt-field-input-numeric').find('[name="monitoring_restriction_field_value_till"]').val('');
            $(element).parents('.tt-field-input-numeric').find('[name="monitoring_restriction_field_value_till_field"]').val(null).trigger('change.select2');
            $(element).parents('.tt-field-input-numeric').find('[name="monitoring_restriction_later_field_value_till"]').prop('checked', false);

            $(element).parents('.tt-field-input-numeric').find('[name="monitoring_restriction_field_logical_till_numeric_field"]').prop('disabled', 'disabled');
            $(element).parents('.tt-field-input-numeric').find('[name="monitoring_restriction_field_value_till"]').prop('disabled', 'disabled');
            $(element).parents('.tt-field-input-numeric').find('[name="monitoring_restriction_field_value_till"]').parent().addClass('state-disabled');
            $(element).parents('.tt-field-input-numeric').find('[name="monitoring_restriction_field_value_till_dropdown_toggle"]').prop('disabled', 'disabled');
            $(element).parents('.tt-field-input-numeric').find('[name="monitoring_restriction_field_value_till_field"]').prop('disabled', 'disabled');
            $(element).parents('.tt-field-input-numeric').find('[name="monitoring_restriction_later_field_value_till"]').prop('disabled', 'disabled');
        }

        // Feld (Datum)
        if ($(element).parents('.tt-field-date').length) {
            $(element).parents('.tt-field-date').find('[name="monitoring_restriction_field_logical_till_date_field"]').val(null).trigger('change.select2');
            $(element).parents('.tt-field-date').find('[name="monitoring_restriction_field_value_till_date"]').val('');
            $(element).parents('.tt-field-date').find('[name="monitoring_restriction_field_value_till_date_field"]').val(null).trigger('change.select2');
            $(element).parents('.tt-field-date').find('[name="monitoring_restriction_field_value_till_date_range"]').val('');
            $(element).parents('.tt-field-date').find('[name="monitoring_restriction_field_value_till_plus_minus"]')[0].checked = false;
            utils.setValueForInputWithDropDownField($(element).parents('.tt-field-date').find('[name="monitoring_restriction_field_value_till_date_range"]').parent(), 'years', true);
            $(element).parents('.tt-field-date').find('[name="monitoring_restriction_later_till_date"]').prop('checked', false);

            $(element).parents('.tt-field-date').find('[name="monitoring_restriction_field_logical_till_date_field"]').prop('disabled', 'disabled');
            $(element).parents('.tt-field-date').find('[name="monitoring_restriction_field_value_till_date"]').prop('disabled', 'disabled');
            $(element).parents('.tt-field-date').find('[name="monitoring_restriction_field_value_till_date"]').parent().addClass('state-disabled');
            $(element).parents('.tt-field-date').find('[name="monitoring_restriction_field_value_till_date_field"]').prop('disabled', 'disabled');
            $(element).parents('.tt-field-date').find('[name="monitoring_restriction_field_value_till_date_range"]').parent().addClass('state-disabled');
            $(element).parents('.tt-field-date').find('[name="monitoring_restriction_field_value_till_date_dropdown_toggle"]').prop('disabled', 'disabled');
            $(element).parents('.tt-field-date').find('[name="monitoring_restriction_field_value_till_date_range"]').prop('disabled', 'disabled');
            $(element).parents('.tt-field-date').find('[name="monitoring_restriction_field_value_till_plus_minus"]').prop('disabled', 'disabled');
            $(element).parents('.tt-field-date').find('[name="monitoring_restriction_later_till_date"]').prop('disabled', 'disabled');
        }

        // Darstellungszeitraum
        if ($(element).parents('.tt-period-restriction').length) {
            $(element).parents('.tt-period-restriction').find('[name="monitoring_restriction_period_logical_till"]').val(null).trigger('change.select2');
            $(element).parents('.tt-period-restriction').find('[name="monitoring_restriction_period_value_till"]').val('');
            $(element).parents('.tt-period-restriction').find('[name="monitoring_restriction_period_value_till_field"]').val(null).trigger('change.select2');
            $(element).parents('.tt-period-restriction').find('[name="monitoring_restriction_period_value_till_date_range"]').val('');
            $(element).parents('.tt-period-restriction').find('[name="monitoring_restriction_period_value_till_plus_minus"]')[0].checked = false;
            utils.setValueForInputWithDropDownField($(element).parents('.tt-period-restriction').find('[name="monitoring_restriction_period_value_till_date_range"]').parent(), 'years', true);
            $(element).parents('.tt-period-restriction').find('[name="monitoring_restriction_later_period_value_till"]').prop('checked', false);

            $(element).parents('.tt-period-restriction').find('[name="monitoring_restriction_period_logical_till"]').prop('disabled', 'disabled');
            $(element).parents('.tt-period-restriction').find('[name="monitoring_restriction_period_value_till"]').prop('disabled', 'disabled');
            $(element).parents('.tt-period-restriction').find('[name="monitoring_restriction_period_value_till"]').parent().addClass('state-disabled');
            $(element).parents('.tt-period-restriction').find('[name="monitoring_restriction_period_value_till_field"]').prop('disabled', 'disabled');
            $(element).parents('.tt-period-restriction').find('[name="monitoring_restriction_period_value_till_date_range"]').parent().addClass('state-disabled');
            $(element).parents('.tt-period-restriction').find('[name="monitoring_restriction_period_value_till_date_dropdown_toggle"]').prop('disabled', 'disabled');
            $(element).parents('.tt-period-restriction').find('[name="monitoring_restriction_period_value_till_date_range"]').prop('disabled', 'disabled');
            $(element).parents('.tt-period-restriction').find('[name="monitoring_restriction_period_value_till_plus_minus"]').prop('disabled', 'disabled');
            $(element).parents('.tt-period-restriction').find('[name="monitoring_restriction_later_period_value_till"]').prop('disabled', 'disabled');
        }

        // Feld auf Dokuseite
        var fieldName = $(element).data().fieldName;
        if (!utils.isUndefined(fieldName) && fieldName !== '') {
            $(element).parents('form').find('[name="monitoring_restriction_logical_till_' + fieldName + '"]').val(null).trigger('change.select2');
            $(element).parents('form').find('[name="monitoring_restriction_' + fieldName + '_till"]').val('');
            $(element).parents('form').find('[name="monitoring_restriction_' + fieldName + '_till_field"]').val(null).trigger('change.select2');

            $(element).parents('form').find('[name="monitoring_restriction_logical_till_' + fieldName + '"]').prop('disabled', 'disabled');
            $(element).parents('form').find('[name="monitoring_restriction_' + fieldName + '_till"]').prop('disabled', 'disabled');
            $(element).parents('form').find('[name="monitoring_restriction_' + fieldName + '_till"]').parent().addClass('state-disabled');
            $(element).parents('form').find('[name="monitoring_restriction_' + fieldName + '_till_dropdown_toggle"]').prop('disabled', 'disabled');
            $(element).parents('form').find('[name="monitoring_restriction_' + fieldName + '_till_field"]').prop('disabled', 'disabled');
        }

    } else {

        // Feld (Input)
        if ($(element).parents('.tt-field-input-numeric').length) {
            $(element).parents('.tt-field-input-numeric').find('[name="monitoring_restriction_field_logical_till_numeric_field"]').prop('disabled', '');
            $(element).parents('.tt-field-input-numeric').find('[name="monitoring_restriction_field_value_till"]').prop('disabled', '');
            $(element).parents('.tt-field-input-numeric').find('[name="monitoring_restriction_field_value_till"]').parent().removeClass('state-disabled');
            $(element).parents('.tt-field-input-numeric').find('[name="monitoring_restriction_field_value_till_dropdown_toggle"]').prop('disabled', '');
            $(element).parents('.tt-field-input-numeric').find('[name="monitoring_restriction_field_value_till_field"]').prop('disabled', '');
            $(element).parents('.tt-field-input-numeric').find('[name="monitoring_restriction_later_field_value_till"]').prop('disabled', '');

            setMonitoringRestrictionValueTill($(element).parents('.tt-field-input-numeric').find('[name="monitoring_restriction_field_value_till_field"]'), '.tt-field-input-numeric');
        }

        // Feld (Datum)
        if ($(element).parents('.tt-field-date').length) {
            $(element).parents('.tt-field-date').find('[name="monitoring_restriction_field_logical_till_date_field"]').prop('disabled', '');
            $(element).parents('.tt-field-date').find('[name="monitoring_restriction_field_value_till_date"]').prop('disabled', '');
            $(element).parents('.tt-field-date').find('[name="monitoring_restriction_field_value_till_date"]').parent().removeClass('state-disabled');
            $(element).parents('.tt-field-date').find('[name="monitoring_restriction_field_value_till_date_field"]').prop('disabled', '');
            $(element).parents('.tt-field-date').find('[name="monitoring_restriction_field_value_till_date_range"]').parent().removeClass('state-disabled');
            $(element).parents('.tt-field-date').find('[name="monitoring_restriction_field_value_till_date_dropdown_toggle"]').prop('disabled', '');
            $(element).parents('.tt-field-date').find('[name="monitoring_restriction_field_value_till_date_range"]').prop('disabled', '');
            $(element).parents('.tt-field-date').find('[name="monitoring_restriction_field_value_till_plus_minus"]').prop('disabled', '');
            $(element).parents('.tt-field-date').find('[name="monitoring_restriction_later_till_date"]').prop('disabled', '');

            setMonitoringRestrictionValueTill($(element).parents('.tt-field-date').find('[name="monitoring_restriction_field_value_till_date_field"]'), '.tt-field-date');
        }

        // Darstellungszeitraum
        if ($(element).parents('.tt-period-restriction').length) {
            $(element).parents('.tt-period-restriction').find('[name="monitoring_restriction_period_logical_till"]').prop('disabled', '');
            $(element).parents('.tt-period-restriction').find('[name="monitoring_restriction_period_value_till"]').prop('disabled', '');
            $(element).parents('.tt-period-restriction').find('[name="monitoring_restriction_period_value_till"]').parent().removeClass('state-disabled');
            $(element).parents('.tt-period-restriction').find('[name="monitoring_restriction_period_value_till_field"]').prop('disabled', '');
            $(element).parents('.tt-period-restriction').find('[name="monitoring_restriction_period_value_till_date_range"]').parent().removeClass('state-disabled');
            $(element).parents('.tt-period-restriction').find('[name="monitoring_restriction_period_value_till_date_dropdown_toggle"]').prop('disabled', '');
            $(element).parents('.tt-period-restriction').find('[name="monitoring_restriction_period_value_till_date_range"]').prop('disabled', '');
            $(element).parents('.tt-period-restriction').find('[name="monitoring_restriction_period_value_till_plus_minus"]').prop('disabled', '');
            $(element).parents('.tt-period-restriction').find('[name="monitoring_restriction_later_period_value_till"]').prop('disabled', '');
        }

        var fieldName = $(element).data().fieldName;
        if (!utils.isUndefined(fieldName) && fieldName !== '') {
            $(element).parents('form').find('[name="monitoring_restriction_logical_till_' + fieldName + '"]').prop('disabled', '');
            $(element).parents('form').find('[name="monitoring_restriction_' + fieldName + '_till"]').prop('disabled', '');
            $(element).parents('form').find('[name="monitoring_restriction_' + fieldName + '_till"]').parent().removeClass('state-disabled');
            $(element).parents('form').find('[name="monitoring_restriction_' + fieldName + '_till_dropdown_toggle"]').prop('disabled', '');
            $(element).parents('form').find('[name="monitoring_restriction_' + fieldName + '_till_field"]').prop('disabled', '');

            setMonitoringRestrictionValueTill($(element).parents('form').find('[name="monitoring_restriction_' + fieldName + '_till_field"]'), 'form');
        }
    }
}

function setMonitoringRestrictionValueTill(element, parent) {
    var range = $(element).attr('data-range');

    if ($(element).val() === '') {
        $(element).parents(parent).find('.tt-monitoring-restriction-deviation-value[data-range="' + range + '"]').prop('disabled', '');
        $(element).parents(parent).find('.tt-monitoring-restriction-deviation-value[data-range="' + range + '"]').parent().removeClass('state-disabled');
        $(element).parents(parent).find('.dropdown-toggle[data-range="' + range + '"]').prop('disabled', '');
        if (element.name === 'monitoring_restriction_period_value_from_field') {
            $(element).parents(parent).find('[name="monitoring_restriction_period_value_from_plus_minus"]')[0].checked = false;
            $(element).parents(parent).find('[name="monitoring_restriction_period_value_from_date_range"]').val('');
        } else if (element.name === 'monitoring_restriction_period_value_till_field') {
            $(element).parents(parent).find('[name="monitoring_restriction_period_value_till_plus_minus"]')[0].checked = false;
            $(element).parents(parent).find('[name="monitoring_restriction_period_value_till_date_range"]').val('');
        }
    } else {
        $(element).parents(parent).find('.tt-monitoring-restriction-deviation-value[data-range="' + range + '"]').prop('disabled', 'disabled');
        $(element).parents(parent).find('.tt-monitoring-restriction-deviation-value[data-range="' + range + '"]').parent().addClass('state-disabled');
        $(element).parents(parent).find('.dropdown-toggle[data-range="' + range + '"]').prop('disabled', 'disabled');
        $(element).parents(parent).find('.tt-monitoring-restriction-deviation-value[data-range="' + range + '"]').val('');
    }
}

function loadMonitoringRestrictionComboboxValues(controlType, controlTypeValues, units, formatFields) {

    // Auswahlliste mit Ausprägungen bei Radiobuttons und Comboboxen befüllen
    var data = [];

    if ((!utils.isUndefined(controlTypeValues) && controlTypeValues !== '') || controlType === 'input' || controlType === 'input_with_additionalfield' || controlType === 'textarea' || controlType === 'date_panel' || controlType === 'date_range') {
        if (!utils.isUndefined(controlTypeValues) && controlTypeValues !== '') {
            var control_types = controlTypeValues.split('|');

            jQuery.each(control_types, function (i, val) {

                var control_type_values = val.split('#');

                if (control_type_values.length === 2) {
                    data.push({ id: control_type_values[0], text: control_type_values[1] });
                }
            });
        } else if (controlType === 'input' || controlType === 'input_with_additionalfield' || controlType === 'textarea') {
            data.push({ id: 0, text: Lang.get('tripletrax.value') });

            if (jQuery.inArray('unknown', formatFields) >= 0) {
                data.push({ id: 1, text: Lang.get('tripletrax.unknown_value') });
            }
            if (jQuery.inArray('not_collected', formatFields) >= 0) {
                data.push({ id: 2, text: Lang.get('tripletrax.not_collected_value') });
            }
            if (jQuery.inArray('not_measurable', formatFields) >= 0) {
                data.push({ id: 3, text: Lang.get('tripletrax.not_measurable_value') });
            }
        } else if (controlType === 'date_panel' || controlType === 'date_range') {
            data.push({ id: 0, text: Lang.get('tripletrax.date') });

            if (jQuery.inArray('unknown', formatFields) >= 0) {
                data.push({ id: 1, text: Lang.get('tripletrax.unknown_value') });
            }
            if (jQuery.inArray('not_collected', formatFields) >= 0) {
                data.push({ id: 2, text: Lang.get('tripletrax.not_collected_value') });
            }
            if (jQuery.inArray('continuing', formatFields) >= 0) {
                data.push({ id: 4, text: Lang.get('tripletrax.continuing_value') });
            }
        }

        validator.reinitializeSelect2($('.monitoring-restriction-field-list'), 'tt-select2 validation-group-monitoring-restriction select2-container', '', data, true, false, true);
    }

    // Auswahlliste für Einheit bei Input-Feldern befüllen
    if (controlType === 'input' || controlType === 'input_with_additionalfield' || controlType === 'textarea') {
        $('.input-with-dropdown-unit').find('ul.dropdown-menu').empty();
        $('.input-with-dropdown-unit').find('.input-with-dropdown').find('i').remove();

        var default_unit = '';
        if (!utils.isUndefined(units) && units !== '') {
            $('.input-with-dropdown-unit').find('input').parent().parent().addClass('display-flex');
            $('.input-with-dropdown-unit').find('input').parent().addClass('input-with-dropdown');
            $('.input-with-dropdown-unit').find('.tt-input-dropdown').removeClass('hide');

            var lab_units_input = units.split('|');
            jQuery.each(lab_units_input, function (i, val) {

                var active = '';
                var lab_unit = val.split('#');

                if (lab_unit[1] === '1') {
                    active = ' class="active"';
                    default_unit = lab_unit[0];
                    $('.input-with-dropdown-unit').find('.input-with-dropdown').append('<i class="icon-append icon-append-unit">' + default_unit + '</i>');
                }

                var item =
                    '<li' + active + '>' +
                    '<a class="tt-select-value tt-select-monitoring-restriction-unit-value" data-format-value="' + lab_unit[0] + '" href="#">' + lab_unit[0] + '</a>' +
                    '</li>';
                $('.input-with-dropdown-unit').find('ul.dropdown-menu').append(item);
            });
        } else {
            $('.input-with-dropdown-unit').find('input').parent().parent().removeClass('display-flex');
            $('.input-with-dropdown-unit').find('input').parent().removeClass('input-with-dropdown');
            $('.input-with-dropdown-unit').find('.tt-input-dropdown').addClass('hide');
        }
    }
}

function setMonitoringRestrictionSavedValues(element, data, enterValuesLater) {

    // Alle Felder zurücksetzen
    $(element).parents('.modal-content').find('input:not([type="hidden"],[type="radio"])').val("");
    $(element).parents('.modal-content').find('input').removeAttr('disabled');
    $(element).parents('.modal-content').find('input').parent().removeClass('state-disabled');
    $(element).parents('.modal-content').find('.dropdown-toggle').prop("disabled", "");
    $(element).parents('.modal-content').find('[type="radio"],[type="checkbox"]').prop('checked', false);
    $(element).parents('.modal-content').find('.tt-select2').val(null).trigger('change.select2');
    $(element).parents('.modal-content').find('.tt-select2').removeAttr('disabled');
    jQuery.each($(element).parents('.modal-content').find('.tt-date-dropdown'), function (i, val) {
        utils.setValueForInputWithDropDownField($(val).parent(), 'years', true);
    });
    $(element).parents('.modal-content').find('[name="monitoring_restriction_later_field_list"]').parent().removeClass('hide');
    $(element).parents('.modal-content').find('.tt-monitoring-restriction-row-specific-values').removeClass('hide');
    $(element).parents('.modal-content').find('.tt-period-restriction').removeClass('hide');
    $(element).parents('.modal-content').find('[name="monitoring_restriction_later_period_value_from"]').parent().removeClass('hide');
    $(element).parents('.modal-content').find('[name="monitoring_restriction_later_period_value_from"]').parents('.row').removeClass('hide');
    $(element).parents('.modal-content').find('[name="monitoring_restriction_later_period_value_till"]').parent().removeClass('hide');
    $(element).parents('.modal-content').find('[name="monitoring_restriction_later_period_value_till"]').parents('.row').removeClass('hide');
    $(element).parents('.modal-content').find('[name="monitoring_restriction_later_field_value_from"]').parent().removeClass('hide');
    $(element).parents('.modal-content').find('[name="monitoring_restriction_later_field_value_from"]').parents('.row').removeClass('hide');
    $(element).parents('.modal-content').find('[name="monitoring_restriction_later_field_value_till"]').parent().removeClass('hide');
    $(element).parents('.modal-content').find('[name="monitoring_restriction_later_field_value_till"]').parents('.row').removeClass('hide');
    $(element).parents('.modal-content').find('[name="monitoring_restriction_later_field_input"]').parent().removeClass('hide');
    $(element).parents('.modal-content').find('[name="monitoring_restriction_later_field_input"]').parents('.row').removeClass('hide');
    $(element).parents('.modal-content').find('[name="monitoring_restriction_later_from_date"]').parent().removeClass('hide');
    $(element).parents('.modal-content').find('[name="monitoring_restriction_later_from_date"]').parents('.row').removeClass('hide');
    $(element).parents('.modal-content').find('[name="monitoring_restriction_later_till_date"]').parent().removeClass('hide');
    $(element).parents('.modal-content').find('[name="monitoring_restriction_later_till_date"]').parents('.row').removeClass('hide');
    $(element).parents('.modal-content').find('.tt-monitoring-restriction-row-and').removeClass('hide');

    // Allgemeine Angaben
    $(element).parents('.modal-content').find('[name="selected_id"]').val(data.id);
    $(element).parents('.modal-content').find('[name="monitoring_restriction_data_view_field"]').val(data.viewId + '|' + data.viewName).trigger('change.select2');

    var table_type = '';
    var table = '';

    if (!utils.isUndefined($(element).parents('.modal-content').find('[name="monitoring_restriction_data_view_field"]').select2('val')) && $(element).parents('.modal-content').find('[name="monitoring_restriction_data_view_field"]').select2('val') !== '') {
        table_type = $(element).parents('.modal-content').find('[name="monitoring_restriction_data_view_field"]').select2('data')[0].tableType;
        table = $(element).parents('.modal-content').find('[name="monitoring_restriction_data_view_field"]').select2('data')[0].table;
    }

    var fieldTableType = '';
    if (table_type === 'master_table' || table_type === 'master_facility_table') {
        fieldTableType = 'master';
    } else if (table_type === 'course_table' || table_type === 'course_facility_table') {
        fieldTableType = 'course';
    } else if (table_type === 'period_table' || table_type === 'period_facility_table') {
        fieldTableType = 'period_' + table;
    }

    setMonitoringRestrictionComboboxItems($(element).parents('.modal-content').find('form'), fieldTableType, false);
    $(element).parents('.modal-content').find('[name="monitoring_restriction_description"]').val(data.description.replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>'));

    showMonitoringRestrictionSpecificFieldsOfValue($(element).parents('.modal-content').find('[name="monitoring_restriction_data_view_field"]'));

    // Feld abhängige Angaben
    var control_type = $(element).parents('.modal-content').find('[name="control_type"]').val();
    var data_type = $(element).parents('.modal-content').find('[name="data_type"]').val();

    if (data.value === 'existing') {
        $(element).parents('.modal-content').find('[name="monitoring_restriction_existing_value"]')[0].checked = true;
        $(element).parents('.modal-content').find('[name="monitoring_restriction_not_existing_value"]')[0].checked = false;
        setMonitoringRestrictionDependingFieldsOfValue($(element).parents('.modal-content').find('[name="monitoring_restriction_existing_value"]'));

    } else if (data.value === 'not_existing') {
        $(element).parents('.modal-content').find('[name="monitoring_restriction_existing_value"]')[0].checked = false;
        $(element).parents('.modal-content').find('[name="monitoring_restriction_not_existing_value"]')[0].checked = true;
        setMonitoringRestrictionDependingFieldsOfValue($(element).parents('.modal-content').find('[name="monitoring_restriction_not_existing_value"]'));

    } else {

        if (control_type === 'input' || control_type === 'input_with_additionalfield' || control_type === 'textarea') {
            if (data_type === 'integer' || data_type === 'decimal') {

                $(element).parents('.modal-content').find('[name="monitoring_restriction_field_logical_from_numeric_field"]').val($("<textarea/>").html(data.valueFromLogicalOperator).text()).trigger('change.select2');

                if (data.valueFromLogicalOperator !== '') {
                    if (data.valueFromDecimal !== '') {
                        $(element).parents('.modal-content').find('[name="monitoring_restriction_field_value_from"]').val(utils.numberToString(parseFloat(data.valueFromDecimal)));
                        utils.setValueForInputWithDropDownField($(element).parents('.modal-content').find('[name="monitoring_restriction_field_value_from"]').parent(), data.unit, true);
                    }
                    if (data.valueFromViewId !== '') {
                        $(element).parents('.modal-content').find('[name="monitoring_restriction_field_value_from"]').val('');
                        $(element).parents('.modal-content').find('[name="monitoring_restriction_field_value_from"]').prop('disabled', 'disabled');
                        $(element).parents('.modal-content').find('[name="monitoring_restriction_field_value_from"]').parent().addClass('state-disabled');
                        $(element).parents('.modal-content').find('[name="monitoring_restriction_field_value_from_field"]').val(data.valueFromViewId + '|' + data.valueFromViewName).trigger('change.select2');
                    }
                } else if (data.valueTillLogicalOperator !== '') {
                    utils.setValueForInputWithDropDownField($(element).parents('.modal-content').find('[name="monitoring_restriction_field_value_from"]').parent(), data.unit, true);
                }

                if (data.valueTillLogicalOperator !== '') {
                    if (data.valueTillDecimal !== '') {
                        $(element).parents('.modal-content').find('[name="monitoring_restriction_field_value_till"]').val(utils.numberToString(parseFloat(data.valueTillDecimal)));
                        utils.setValueForInputWithDropDownField($(element).parents('.modal-content').find('[name="monitoring_restriction_field_value_till"]').parent(), data.unit, true);
                    }
                    if (data.valueTillViewId !== '') {
                        $(element).parents('.modal-content').find('[name="monitoring_restriction_field_value_till"]').val('');
                        $(element).parents('.modal-content').find('[name="monitoring_restriction_field_value_till"]').prop('disabled', 'disabled');
                        $(element).parents('.modal-content').find('[name="monitoring_restriction_field_value_till"]').parent().addClass('state-disabled');
                        $(element).parents('.modal-content').find('[name="monitoring_restriction_field_value_till_field"]').val(data.valueTillViewId + '|' + data.valueTillViewName).trigger('change.select2');
                    }
                } else if (data.valueFromLogicalOperator !== '') {
                    utils.setValueForInputWithDropDownField($(element).parents('.modal-content').find('[name="monitoring_restriction_field_value_till"]').parent(), data.unit, true);
                }

                setMonitoringRestrictionFieldsDependingOnLogicalOperator($(element).parents('.modal-content').find('[name="monitoring_restriction_field_logical_from_numeric_field"]'));
                $(element).parents('.modal-content').find('[name="monitoring_restriction_field_logical_till_numeric_field"]').val($("<textarea/>").html(data.valueTillLogicalOperator).text()).trigger('change.select2');

                if (enterValuesLater) {
                    $(element).parents('.modal-content').find('[name="monitoring_restriction_field_logical_from_numeric_field"]').attr('disabled', 'disabled');
                    $(element).parents('.modal-content').find('[name="monitoring_restriction_field_logical_till_numeric_field"]').attr('disabled', 'disabled');
                    if (data.valueFromLater === '1' || data.valueFromLater === 1 || data.valueTillLater === '1' || data.valueTillLater === 1) {
                        if (data.valueFromLater === '1' || data.valueFromLater === 1) {
                            $(element).parents('.modal-content').find('[name="monitoring_restriction_later_field_value_from"]').parent().addClass('hide');
                        } else {
                            $($(element).parents('.modal-content').find('[name="monitoring_restriction_later_field_value_from"]').parents('.row')[0]).addClass('hide');
                            $(element).parents('.modal-content').find('.tt-monitoring-restriction-row-and').addClass('hide');
                        }
                        if (data.valueTillLater === '1' || data.valueTillLater === 1) {
                            $(element).parents('.modal-content').find('[name="monitoring_restriction_later_field_value_till"]').parent().addClass('hide');
                        } else {
                            $($(element).parents('.modal-content').find('[name="monitoring_restriction_later_field_value_till"]').parents('.row')[0]).addClass('hide');
                            $(element).parents('.modal-content').find('.tt-monitoring-restriction-row-and').addClass('hide');
                        }
                    } else {
                        $($(element).parents('.modal-content').find('[name="monitoring_restriction_later_field_value_from"]').parents('.row')[0]).addClass('hide');
                        $($(element).parents('.modal-content').find('[name="monitoring_restriction_later_field_value_till"]').parents('.row')[0]).addClass('hide');
                        $(element).parents('.modal-content').find('.tt-monitoring-restriction-row-and').addClass('hide');
                    }
                } else {
                    $(element).parents('.modal-content').find('[name="monitoring_restriction_later_field_value_from"]')[0].checked = (data.valueFromLater === '1' || data.valueFromLater === 1);
                    if ($(element).parents('.modal-content').find('[name="monitoring_restriction_later_field_value_from"]')[0].checked) {
                        $(element).parents('.modal-content').find('[name="monitoring_restriction_later_field_value_from"]').change();
                    }

                    $(element).parents('.modal-content').find('[name="monitoring_restriction_later_field_value_till"]')[0].checked = (data.valueTillLater === '1' || data.valueTillLater === 1);
                    if ($(element).parents('.modal-content').find('[name="monitoring_restriction_later_field_value_till"]')[0].checked) {
                        $(element).parents('.modal-content').find('[name="monitoring_restriction_later_field_value_till"]').change();
                    }
                }

            } else {

                $(element).parents('.modal-content').find('[name="monitoring_restriction_field_logical_text_field"]').val($("<textarea/>").html(data.valueFromLogicalOperator).text()).trigger('change.select2');
                if (data.valueFromString !== '') {
                    $(element).parents('.modal-content').find('[name="monitoring_restriction_field_input"]').val(data.valueFromString);
                }

                if (enterValuesLater) {
                    $(element).parents('.modal-content').find('[name="monitoring_restriction_field_logical_text_field"]').attr('disabled', 'disabled');
                    if (data.valueFromLater === '1' || data.valueFromLater === 1) {
                        $(element).parents('.modal-content').find('[name="monitoring_restriction_later_field_input"]').parent().addClass('hide');
                    } else {
                        $(element).parents('.modal-content').find('[name="monitoring_restriction_later_field_input"]').parents('.row').addClass('hide');
                    }
                } else {
                    $(element).parents('.modal-content').find('[name="monitoring_restriction_later_field_input"]')[0].checked = (data.valueFromLater === '1' || data.valueFromLater === 1);
                    if ($(element).parents('.modal-content').find('[name="monitoring_restriction_later_field_input"]')[0].checked) {
                        $(element).parents('.modal-content').find('[name="monitoring_restriction_later_field_input"]').change();
                    }
                }

            }

        } else if (control_type === 'date_panel' || control_type === 'date_range') {

            $(element).parents('.modal-content').find('[name="monitoring_restriction_field_logical_from_date_field"]').val($("<textarea/>").html(data.valueFromLogicalOperator).text()).trigger('change.select2');

            if (data.valueFromViewId !== '') {
                if (data.valueFromUpDown === '+') {
                    $(element).parents('.modal-content').find('[name="monitoring_restriction_field_value_from_plus_minus"]')[0].checked = false;
                } else {
                    $(element).parents('.modal-content').find('[name="monitoring_restriction_field_value_from_plus_minus"]')[0].checked = true;
                }
                $(element).parents('.modal-content').find('[name="monitoring_restriction_field_value_from_date_field"]').val(data.valueFromViewId + '|' + data.valueFromViewName).trigger('change.select2');
                $(element).parents('.modal-content').find('[name="monitoring_restriction_field_value_from_date_range"]').val(data.valueFromValue);
                utils.setValueForInputWithDropDownField($(element).parents('.modal-content').find('[name="monitoring_restriction_field_value_from_date_range"]').parent(), data.valueFromRange, true);
            } else {
                if (data.valueFromDate !== '') {
                    $(element).parents('.modal-content').find('[name="monitoring_restriction_field_value_from_date"]').data('picker').setDate(utils.stringToDate(data.valueFromDate));
                }
            }

            if (data.valueTillViewId !== '') {
                if (data.valueTillUpDown === '+') {
                    $(element).parents('.modal-content').find('[name="monitoring_restriction_field_value_till_plus_minus"]')[0].checked = false;
                } else {
                    $(element).parents('.modal-content').find('[name="monitoring_restriction_field_value_till_plus_minus"]')[0].checked = true;
                }
                $(element).parents('.modal-content').find('[name="monitoring_restriction_field_value_till_date_field"]').val(data.valueTillViewId + '|' + data.valueTillViewName).trigger('change.select2');
                $(element).parents('.modal-content').find('[name="monitoring_restriction_field_value_till_date_range"]').val(data.valueTillValue);
                utils.setValueForInputWithDropDownField($(element).parents('.modal-content').find('[name="monitoring_restriction_field_value_till_date_range"]').parent(), data.valueTillRange, true);
            } else {
                if (data.valueTillDate !== '') {
                    $(element).parents('.modal-content').find('[name="monitoring_restriction_field_value_till_date"]').data('picker').setDate(utils.stringToDate(data.valueTillDate));
                }
            }

            setMonitoringRestrictionFieldsDependingOnLogicalOperator($(element).parents('.modal-content').find('[name="monitoring_restriction_field_logical_from_date_field"]'));
            $(element).parents('.modal-content').find('[name="monitoring_restriction_field_logical_till_date_field"]').val($("<textarea/>").html(data.valueTillLogicalOperator).text()).trigger('change.select2');

            if (enterValuesLater) {
                $(element).parents('.modal-content').find('[name="monitoring_restriction_field_logical_from_date_field"]').attr('disabled', 'disabled');
                $(element).parents('.modal-content').find('[name="monitoring_restriction_field_logical_till_date_field"]').attr('disabled', 'disabled');
                if (data.valueFromLater === '1' || data.valueFromLater === 1 || data.valueTillLater === '1' || data.valueTillLater === 1) {
                    if (data.valueFromLater === '1' || data.valueFromLater === 1) {
                        $(element).parents('.modal-content').find('[name="monitoring_restriction_later_from_date"]').parent().addClass('hide');
                    } else {
                        $($(element).parents('.modal-content').find('[name="monitoring_restriction_later_from_date"]').parents('.row')[0]).addClass('hide');
                        $(element).parents('.modal-content').find('.tt-monitoring-restriction-row-and').addClass('hide');
                    }
                    if (data.valueTillLater === '1' || data.valueTillLater === 1) {
                        $(element).parents('.modal-content').find('[name="monitoring_restriction_later_till_date"]').parent().addClass('hide');
                    } else {
                        $($(element).parents('.modal-content').find('[name="monitoring_restriction_later_till_date"]').parents('.row')[0]).addClass('hide');
                        $(element).parents('.modal-content').find('.tt-monitoring-restriction-row-and').addClass('hide');
                    }
                } else {
                    $($(element).parents('.modal-content').find('[name="monitoring_restriction_later_from_date"]').parents('.row')[0]).addClass('hide');
                    $($(element).parents('.modal-content').find('[name="monitoring_restriction_later_till_date"]').parents('.row')[0]).addClass('hide');
                    $(element).parents('.modal-content').find('.tt-monitoring-restriction-row-and').addClass('hide');
                }
            } else {
                $(element).parents('.modal-content').find('[name="monitoring_restriction_later_from_date"]')[0].checked = (data.valueFromLater === '1' || data.valueFromLater === 1);
                if ($(element).parents('.modal-content').find('[name="monitoring_restriction_later_from_date"]')[0].checked) {
                    $(element).parents('.modal-content').find('[name="monitoring_restriction_later_from_date"]').change();
                }

                $(element).parents('.modal-content').find('[name="monitoring_restriction_later_till_date"]')[0].checked = (data.valueTillLater === '1' || data.valueTillLater === 1);
                if ($(element).parents('.modal-content').find('[name="monitoring_restriction_later_till_date"]')[0].checked) {
                    $(element).parents('.modal-content').find('[name="monitoring_restriction_later_till_date"]').change();
                }
            }

        } else if (control_type !== 'checkbox') {

            $(element).parents('.modal-content').find('[name="monitoring_restriction_not_field_list"]')[0].checked = (data.value === 'not');
            $(element).parents('.modal-content').find('[name="monitoring_restriction_field_list"]').val(data.rangeOfValues.toString().split('$')).trigger('change.select2');
            if (enterValuesLater) {
                if (data.valueFromLater === '1' || data.valueFromLater === 1) {
                    $(element).parents('.modal-content').find('[name="monitoring_restriction_later_field_list"]').parent().addClass('hide');
                } else {
                    $(element).parents('.modal-content').find('.tt-monitoring-restriction-row-specific-values').addClass('hide');
                }
            } else {
                $(element).parents('.modal-content').find('[name="monitoring_restriction_later_field_list"]')[0].checked = (data.valueFromLater === '1' || data.valueFromLater === 1);
                if ($(element).parents('.modal-content').find('[name="monitoring_restriction_later_field_list"]')[0].checked) {
                    $(element).parents('.modal-content').find('[name="monitoring_restriction_later_field_list"]').change();
                }
            }
        }
    }

    // Darstellungszeitraum
    $(element).parents('.modal-content').find('[name="monitoring_restriction_period_logical_from"]').val($("<textarea/>").html(data.periodFromLogicalOperator).text()).trigger('change.select2');
    if (data.periodFromViewId !== '') {
        if (data.periodFromUpDown === '+') {
            $(element).parents('.modal-content').find('[name="monitoring_restriction_period_value_from_plus_minus"]')[0].checked = false;
        } else {
            $(element).parents('.modal-content').find('[name="monitoring_restriction_period_value_from_plus_minus"]')[0].checked = true;
        }
        $(element).parents('.modal-content').find('[name="monitoring_restriction_period_value_from_field"]').val(data.periodFromViewId + '|' + data.periodFromViewName).trigger('change.select2');
        $(element).parents('.modal-content').find('[name="monitoring_restriction_period_value_from_date_range"]').val(data.periodFromValue);
        utils.setValueForInputWithDropDownField($(element).parents('.modal-content').find('[name="monitoring_restriction_period_value_from_date_range"]').parent(), data.periodFromRange, true);
    } else {
        if (data.periodFromDate !== '') {
            $(element).parents('.modal-content').find('[name="monitoring_restriction_period_value_from"]').data('picker').setDate(utils.stringToDate(data.periodFromDate));
        }
    }

    setMonitoringRestrictionFieldsDependingOnLogicalOperator($(element).parents('.modal-content').find('[name="monitoring_restriction_period_logical_from"]'));

    $(element).parents('.modal-content').find('[name="monitoring_restriction_period_logical_till"]').val($("<textarea/>").html(data.periodTillLogicalOperator).text()).trigger('change.select2');
    if (data.periodTillViewId !== '') {
        if (data.periodTillUpDown === '+') {
            $(element).parents('.modal-content').find('[name="monitoring_restriction_period_value_till_plus_minus"]')[0].checked = false;
        } else {
            $(element).parents('.modal-content').find('[name="monitoring_restriction_period_value_till_plus_minus"]')[0].checked = true;
        }
        $(element).parents('.modal-content').find('[name="monitoring_restriction_period_value_till_field"]').val(data.periodTillViewId + '|' + data.periodTillViewName).trigger('change.select2');
        $(element).parents('.modal-content').find('[name="monitoring_restriction_period_value_till_field"]').change();
        $(element).parents('.modal-content').find('[name="monitoring_restriction_period_value_till_date_range"]').val(data.periodTillValue);
        utils.setValueForInputWithDropDownField($(element).parents('.modal-content').find('[name="monitoring_restriction_period_value_till_date_range"]').parent(), data.periodTillRange, true);
    } else {
        if (data.periodTillDate !== '') {
            $(element).parents('.modal-content').find('[name="monitoring_restriction_period_value_till"]').data('picker').setDate(utils.stringToDate(data.periodTillDate));
        }
    }

    if (enterValuesLater) {
        $(element).parents('.modal-content').find('[name="monitoring_restriction_period_logical_from"]').attr('disabled', 'disabled');
        $(element).parents('.modal-content').find('[name="monitoring_restriction_period_logical_till"]').attr('disabled', 'disabled');
        if (data.periodFromLater === '1' || data.periodFromLater === 1 || data.periodTillLater === '1' || data.periodTillLater === 1) {
            if (data.periodFromLater === '1' || data.periodFromLater === 1) {
                $(element).parents('.modal-content').find('[name="monitoring_restriction_later_period_value_from"]').parent().addClass('hide');
            } else {
                $($(element).parents('.modal-content').find('[name="monitoring_restriction_later_period_value_from"]').parents('.row')[0]).addClass('hide');
                $(element).parents('.modal-content').find('.tt-monitoring-restriction-period-row-and').addClass('hide');
            }
            if (data.periodTillLater === '1' || data.periodTillLater === 1) {
                $(element).parents('.modal-content').find('[name="monitoring_restriction_later_period_value_till"]').parent().addClass('hide');
            } else {
                $($(element).parents('.modal-content').find('[name="monitoring_restriction_later_period_value_till"]').parents('.row')[0]).addClass('hide');
                $(element).parents('.modal-content').find('.tt-monitoring-restriction-period-row-and').addClass('hide');
            }
        } else {
            $(element).parents('.modal-content').find('.tt-period-restriction').addClass('hide');
        }
    } else {
        $(element).parents('.modal-content').find('[name="monitoring_restriction_later_period_value_from"]')[0].checked = (data.periodFromLater === '1' || data.periodFromLater === 1);
        if ($(element).parents('.modal-content').find('[name="monitoring_restriction_later_period_value_from"]')[0].checked) {
            $(element).parents('.modal-content').find('[name="monitoring_restriction_later_period_value_from"]').change();
        }

        $(element).parents('.modal-content').find('[name="monitoring_restriction_later_period_value_till"]')[0].checked = (data.periodTillLater === '1' || data.periodTillLater === 1);
        if ($(element).parents('.modal-content').find('[name="monitoring_restriction_later_period_value_till"]')[0].checked) {
            $(element).parents('.modal-content').find('[name="monitoring_restriction_later_period_value_till"]').change();
        }
    }

    if (enterValuesLater) {
        $(element).parents('.modal-content').find('[name="monitoring_restriction_data_view_field"]').attr('disabled', 'disabled');
        $(element).parents('.modal-content').find('[name="monitoring_restriction_description"]').attr('disabled', 'disabled').addClass('disabled');
        $(element).parents('.modal-content').find('[name="monitoring_restriction_existing_value"]').parents('.row').addClass('hide');
        $(element).parents('.modal-content').find('[name="monitoring_restriction_not_existing_value"]').parents('.row').addClass('hide');
        $(element).parents('.modal-content').find('.tt-monitoring-restriction-or').addClass('hide');
    }
}

function loadCustomMonitoringPatientlist(id) {

    return $.Deferred(function (defer) {
        var patientData = null;
        $('#table_monitoring_custom_' + id).find('.dataTables_empty').text('').append('<h1><i class="fad fa-cog fa-spin"></i> ' + Lang.get('tripletrax.loading') + '...</h1>');

        ajax.ajaxCallDeferred('doc/patient/monitoring/custom/sql/' + id, 'GET', $('#table_monitoring_custom_' + id).data('monitoring_restrictions'), false).done(function (data) {
            if (ajax.ajaxSucceeded(data)) {

                patientData = data;
                patients.loadIDATPatientList(views.getFacilityId(), views.getModelId(), true).done(function () {

                    defer.resolve(patientData);
                });
            } else {
                defer.reject();
            }
        });

    }).promise();
}

function checkCustomMonitoringEnterValuesLater() {

    return $.Deferred(function (defer) {
        if ($('.tt-select-monitoring').length && !utils.isUndefined($('.tt-select-monitoring').select2('val')) && $('.tt-select-monitoring').select2('val') !== '' && $('.tt-select-monitoring').select2('data')[0].element.dataset.enterValueLater !== '') {
            $('#content-detail').empty();

            ajax.ajaxCallDeferred($('.tt-select-monitoring').select2('data')[0].element.dataset.enterValueLater, 'GET', '', false).done(function (data) {
                if (ajax.ajaxSucceeded(data)) {

                    if (data === '') {
                        defer.resolve(false);
                    } else {
                        utils.setHtmlData($('#content-detail'), data, true);
                        defer.resolve(true);
                    }
                } else {
                    defer.reject();
                }
            });
        } else {
            defer.resolve(false);
        }

    }).promise();
}


module.exports.registerMonitoringEvents = registerMonitoringEvents;
module.exports.setMonitoringRestrictionComboboxItems = setMonitoringRestrictionComboboxItems;
module.exports.setMonitoringRestrictionFieldSelection = setMonitoringRestrictionFieldSelection;
module.exports.showMonitoringRestrictionSpecificFieldsOfValue = showMonitoringRestrictionSpecificFieldsOfValue;
module.exports.setMonitoringRestrictionDependingFieldsOfValue = setMonitoringRestrictionDependingFieldsOfValue;
module.exports.loadCustomMonitoringPatientlist = loadCustomMonitoringPatientlist;
